"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InternalController", {
    enumerable: true,
    get: function() {
        return InternalController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _operationScopes = require("~/controllers/internal/operationScopes");
const _internaltype = require("~/utils/internal-type");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _globalguard = require("~/guards/global/global.guard");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _catchError = require("~/helpers/catchError");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _models = require("~/models");
const _globals = require("~/utils/globals");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let InternalController = class InternalController {
    async checkAcl(operation, req, scope) {
        // For filter/sort/view operations, extract view to check personal view ownership
        const filterSortOperations = [
            'filterList',
            'filterChildrenList',
            'filterCreate',
            'filterUpdate',
            'filterDelete',
            'sortList',
            'sortCreate',
            'sortUpdate',
            'sortDelete',
            'viewUpdate',
            'viewColumnUpdate',
            'viewColumnCreate',
            'hideAllColumns',
            'showAllColumns',
            'gridViewUpdate',
            'gridColumnUpdate',
            'galleryViewUpdate',
            'kanbanViewUpdate',
            'mapViewUpdate',
            'calendarViewUpdate',
            'viewRowColorConditionAdd',
            'viewRowColorConditionUpdate',
            'viewRowColorConditionDelete',
            'viewRowColorSelectAdd',
            'viewRowColorInfoDelete',
            'rowColorConditionsFilterCreate'
        ];
        if (filterSortOperations.includes(operation)) {
            var _req_body;
            const bypassContext = {
                workspace_id: _globals.RootScopes.BYPASS,
                base_id: _globals.RootScopes.BYPASS
            };
            let view = null;
            // Extract view based on the operation parameters
            if (req.query.viewId) {
                view = await _models.View.get(bypassContext, req.query.viewId);
            } else if ((_req_body = req.body) == null ? void 0 : _req_body.fk_view_id) {
                // For create operations (filterCreate, sortCreate, etc.) where viewId is in body
                view = await _models.View.get(bypassContext, req.body.fk_view_id);
            } else if (req.query.filterId) {
                const filter = await _models.Filter.get(bypassContext, req.query.filterId);
                if (filter == null ? void 0 : filter.fk_view_id) {
                    view = await _models.View.get(bypassContext, filter.fk_view_id);
                }
            } else if (req.query.sortId) {
                const sort = await _models.Sort.get(bypassContext, req.query.sortId);
                if (sort == null ? void 0 : sort.fk_view_id) {
                    view = await _models.View.get(bypassContext, sort.fk_view_id);
                }
            } else if (req.query.gridViewColumnId) {
                const gridCol = await _models.GridViewColumn.get(bypassContext, req.query.gridViewColumnId);
                if (gridCol == null ? void 0 : gridCol.fk_view_id) {
                    view = await _models.View.get(bypassContext, gridCol.fk_view_id);
                }
            }
            // Set view in request for personal view ownership check in ACL middleware
            if (view && view.lock_type === _nocodbsdk.ViewLockType.Personal) {
                req[_extractidsmiddleware.VIEW_KEY] = view;
            }
        }
        await this.aclMiddleware.aclFn(operation, {
            scope
        }, null, req);
    }
    async internalAPI(context, workspaceId, baseId, operation, req) {
        await this.checkAcl(operation, req, _operationScopes.OPERATION_SCOPES[operation]);
        const module = this.internalApiModuleMap['GET'][operation];
        if (module) {
            return module.handle(context, {
                workspaceId,
                baseId,
                operation,
                req
            });
        }
        return _catchError.NcError.notFound('Operation');
    }
    async internalAPIPost(context, workspaceId, baseId, operation, payload, req) {
        await this.checkAcl(operation, req, _operationScopes.OPERATION_SCOPES[operation]);
        const module = this.internalApiModuleMap['POST'][operation];
        if (module) {
            return module.handle(context, {
                workspaceId,
                baseId,
                operation,
                req,
                payload
            });
        }
        return _catchError.NcError.notFound('Operation');
    }
    constructor(aclMiddleware, internalApiModules){
        this.aclMiddleware = aclMiddleware;
        this.internalApiModules = internalApiModules;
        this.internalApiModuleMap = {};
        if (!this.internalApiModuleMap) {
            this.internalApiModuleMap = {};
        }
        for (const each of internalApiModules){
            var _this_internalApiModuleMap_each_httpMethod;
            this.internalApiModuleMap[each.httpMethod] = (_this_internalApiModuleMap_each_httpMethod = this.internalApiModuleMap[each.httpMethod]) != null ? _this_internalApiModuleMap_each_httpMethod : {};
            for (const operation of each.operations){
                this.internalApiModuleMap[each.httpMethod][operation] = each;
            }
        }
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/internal/:workspaceId/:baseId'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('workspaceId')),
    _ts_param(2, (0, _common.Param)('baseId')),
    _ts_param(3, (0, _common.Query)('operation')),
    _ts_param(4, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nocodbsdk.NcContext === "undefined" ? Object : _nocodbsdk.NcContext,
        String,
        String,
        Object,
        typeof _nocodbsdk.NcRequest === "undefined" ? Object : _nocodbsdk.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], InternalController.prototype, "internalAPI", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/internal/:workspaceId/:baseId'
    ]),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('workspaceId')),
    _ts_param(2, (0, _common.Param)('baseId')),
    _ts_param(3, (0, _common.Query)('operation')),
    _ts_param(4, (0, _common.Body)()),
    _ts_param(5, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nocodbsdk.NcContext === "undefined" ? Object : _nocodbsdk.NcContext,
        String,
        String,
        Object,
        Object,
        typeof _nocodbsdk.NcRequest === "undefined" ? Object : _nocodbsdk.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], InternalController.prototype, "internalAPIPost", null);
InternalController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(1, (0, _common.Inject)(_internaltype.INTERNAL_API_MODULE_PROVIDER_KEY)),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _extractidsmiddleware.AclMiddleware === "undefined" ? Object : _extractidsmiddleware.AclMiddleware,
        Array
    ])
], InternalController);
